/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest } from 'redux-saga/effects';

import * as commonSagas from '../_common/commonSagas';
import * as licensesSlice from './licensesSlice';

export default function* watchLicensesSaga() {
 yield takeLatest(licensesSlice.getTableStart.type, commonSagas.getTable);
 yield takeLatest(licensesSlice.getItemStart.type, commonSagas.getItem);
 yield takeLatest(licensesSlice.createItemStart.type, commonSagas.createItem);
 yield takeLatest(licensesSlice.updateItemStart.type, commonSagas.updateItem);
 yield takeLatest(licensesSlice.deleteItemStart.type, commonSagas.deleteItem);
 yield takeLatest(
  licensesSlice.getTableStructureStart.type,
  commonSagas.getTableStructure,
 );
 yield takeLatest(
  licensesSlice.getItemDocumentsStart.type,
  commonSagas.getItemDocuments,
 );
 yield takeLatest(
  licensesSlice.uploadItemDocumentsStart.type,
  commonSagas.uploadItemDocuments,
 );
 yield takeLatest(
  licensesSlice.deleteItemDocumentStart.type,
  commonSagas.deleteItemDocument,
 );
 yield takeLatest(
  licensesSlice.getTableExcelStart.type,
  commonSagas.getTableExcel,
 );
}
